import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Accordion, Icon, Message, Menu, Button, Input, Grid} from 'semantic-ui-react';
import {isNoU} from "../../utils/DBUtils";
import {injectIntl, intlShape} from 'react-intl';
import ErrorDisplay from "./ErrorDisplay";
import {FormattedMessage} from 'react-intl';
import {isTruthy} from "../../utils/DBUtils";

const AccordionMessage = (props) => {
    let primaryClass = "db-accordion-message";
    let classes = props.className ? primaryClass + " " + props.className : primaryClass;

    return (
      <div className={classes}>
        <Message>
          <Message.Header>{props.header}</Message.Header>
          {props.messageInputs}

          {!isNoU(props.inputs) ?
            props.inputs.map((input,index) => {
              return(
                <div className="accordion-message-input">

                <Grid columns="equal">
                  <Grid.Row className="db-field-label-row">
                      {input.label ?
                        <Fragment>
                          {input.required ? <i className="asterisk icon inline"/> : ""}
                            {input.label}
                        </Fragment>
                      : ""}
                  </Grid.Row>
                  <Grid.Row>
                    <Input onChange={input.onChange} error={isTruthy(props.formError)} placeholder={props.intl.formatMessage({ id: input.placeholderKey})}/>
                    {props.hasError ? <ErrorDisplay error={input.error}/> : ""}
                    <ErrorDisplay error={props.formError}/>
                  </Grid.Row>
                </Grid>
                </div>
              )
            })


            : ""}
          <div className="accordion-message-buttons">

            {!isNoU(props.actions) ? props.actions.map((action, index) => {
              switch(action.type) {
                case 'menu-item': {
                  return (<Menu.Item key={action.label + index}
                             className={action.customStyle}
                             onClick={action.action}>
                      {action.label}
                  </Menu.Item>);
                  break;
                }
                case 'button': {
                  return(<Button primary={action.primaryCheck}
                          key={action.label + index}
                          className={action.customStyle}
                          disabled={action.isDisabled}
                          onClick={action.action}>
                          {action.label}
                  </Button>);
                  break;
                }
              }
            }) : ""}
          </div>
        </Message>
        {props.wasSuccess ?
          <Message className="success-message animResponse fadeInDown">
            <Message.Header><FormattedMessage id={'editbreak.colors.savePaletteSuccess'}/></Message.Header>
          </Message>
           : ""}

    </div>
  )
};

AccordionMessage.propTypes = {
    header: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.node.isRequired
    ]),
    className: PropTypes.string,
    inputs: PropTypes.array,
    actions: PropTypes.array,
    messageType: PropTypes.string,
    content: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.node.isRequired
    ]),
    intl: intlShape.isRequired,
    hasError:PropTypes.bool
};


export default injectIntl(AccordionMessage);



// WEBPACK FOOTER //
// ./public/components/common/AccordionMessage.jsx